import Class from '@/Class';

export default class StateCounter<T> extends Class {
    private count: number;

    constructor(
        private stateObs: KnockoutObservable<T>,
        private threshold: number,
        private belowOrAtThresholdValueProvider: () => T,
        private aboveThresholdValueProvider: () => T
    ) {
        super();

        this.isDisposable = true;

        this.count = 0;
    }

    private isBelowOrAtThreshold() {
        return this.count <= this.threshold;
    }

    private update(action: Function) {
        const belowOrAtThresholdBefore = this.isBelowOrAtThreshold();

        action();

        const belowOrAtThresholdNow = this.isBelowOrAtThreshold();
        if (belowOrAtThresholdBefore != belowOrAtThresholdNow) {
            const value = belowOrAtThresholdNow ? this.belowOrAtThresholdValueProvider() : this.aboveThresholdValueProvider();
            this.stateObs(value);
        }
    }

    public increment(): void {
        this.update(() => {
            this.count++;
        });
    }

    public decrement(): void {
        this.update(() => {
            this.count--;
        });
    }
}